import { render, staticRenderFns } from "./addNotice.vue?vue&type=template&id=1877ed46&scoped=true&"
import script from "./addNotice.vue?vue&type=script&lang=ts&"
export * from "./addNotice.vue?vue&type=script&lang=ts&"
import style0 from "./addNotice.vue?vue&type=style&index=0&id=1877ed46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1877ed46",
  null
  
)

export default component.exports